import React, { useEffect } from "react";
import { Page, BlockTitle, List, ListItem, Badge } from "framework7-react";
import _ from "lodash";

import HasRole from "modules/5_view_helpers/HasRole";
import QASidebar from "modules/project/qa/mobile/QASidebar";
import StoreSidebar from "modules/store/mobile/StoreSidebar";
import CustomFormMenuModuleSidebar from "./AppSidebar/CustomFormMenuModuleSidebar";
import {
  buildRootNavItems,
  getMenuModuleId,
  getMobileCustomForms,
  getMobileMenus,
  getMobileSidebarType,
  MobileNavList,
} from "./AppSidebar/helpers";
import { connect } from "react-redux";
import { getCustomForms } from "modules/custom_forms/actions";
import { getCustomFormsMenus } from "modules/custom_forms/menus/actions";

const mapStateToProps = (state) => ({
  custom_forms: state.custom_forms,
  custom_forms_menus: state.custom_forms_menus,
  current_user: state.current_user,
});

const AppSidebar = (props) => {
  const {
    custom_forms,
    custom_forms_menus,
    current_user: { approvals_left },
  } = props;

  const drawingsReadRole = HasRole(
    {
      resource_type: "Project::Drawing",
      name: ["read", "moderator"],
    },
    true
  );
  const customFormsRoles = HasRole({ resource_type: "CustomForm", name: ["read", "moderator"] }, true);
  const customFormsMenuRoles = HasRole({ resource_type: "CustomForms::Menu",name: ["read", "moderator"] }, true);

  useEffect(() => {
    if (customFormsRoles) {
      props.getCustomForms();
    }
    if (customFormsMenuRoles) {
      props.getCustomFormsMenus();
    }
  }, []);
  const StoreModuleRole = HasRole({ name: "Store_Module_Access" }, true);
  const StoreRequestRoles =
    HasRole({ resource_type: "Store::Request", name: ["create", "moderator"] }, true) ||
    HasRole({ name: "Show_All_Store_Requests" }, true);

  const { pathname } = location;
  const customFormMatch = pathname.match(/\/custom_form\/(\d+)\/records/);
  const custom_form = customFormMatch && custom_forms[customFormMatch[1]];
  const sidebarType = getMobileSidebarType(pathname, custom_form, custom_forms_menus);
  const menuModuleId = getMenuModuleId(pathname, custom_form, custom_forms_menus);

  const mobileCustomForms = getMobileCustomForms(custom_forms);
  const mobileMenus = getMobileMenus(custom_forms_menus);
  const rootNavItems = buildRootNavItems(mobileCustomForms, mobileMenus, custom_forms);

  if (sidebarType === "qa") {
    return <QASidebar {...props} mobileCustomForms={mobileCustomForms} mobileMenus={mobileMenus} />;
  }
  if (sidebarType === "store") {
    return <StoreSidebar {...props} mobileCustomForms={mobileCustomForms} mobileMenus={mobileMenus} />;
  }
  if (sidebarType === "custom_forms_menu_module" && menuModuleId) {
    return (
      <CustomFormMenuModuleSidebar
        menuId={menuModuleId}
        custom_forms={custom_forms}
        custom_forms_menus={custom_forms_menus}
      />
    );
  }

  return (
    <Page>
      <BlockTitle>Main Navigation</BlockTitle>
      <List>
        <ListItem link="/project/qa" title="Quality Assurance" panelClose />
        {drawingsReadRole && <ListItem link="/project/drawings" title="Drawings" panelClose />}
        {StoreModuleRole && <ListItem link="/store" title="Store" panelClose />}
        {StoreRequestRoles && <ListItem link="/store/requests" title="Store Requests" panelClose />}
      </List>
      {customFormsRoles && <MobileNavList items={rootNavItems} />}
      <List>
        <ListItem link="/approvals" title="Approvals" panelClose>
          {approvals_left > 0 && <Badge color="red">{approvals_left}</Badge>}
        </ListItem>
      </List>
    </Page>
  );
};

export default connect(mapStateToProps, { getCustomForms, getCustomFormsMenus })(AppSidebar);
